import { ref, watch } from "vue"
import { useMsal } from "./useMsal"

export function useIsAuthenticated() {
    var accounts = useMsal().accounts
    var isAuthenticated = ref(accounts.value.length > 0)
    watch(accounts, function () {
        isAuthenticated.value = accounts.value.length > 0
    })
    return isAuthenticated
}
